export default __webpack_public_path__ + "static/media/_calculator_beroas.0178a4cf.svg";